import type { App } from 'vue'
import { createI18n } from 'vue-i18n'
import { getPageLangCode } from '@web-publish-id/shared'

import zhCN from './lang/zh-cn'
import zhTW from './lang/zh-tw'
import en from './lang/en'
import ja from './lang/ja'
import ar from './lang/ar'
import ko from './lang/ko'
import de from './lang/de'
import fr from './lang/fr'
import ru from './lang/ru'
import es from './lang/es'
import pt from './lang/pt'
import th from './lang/th'
import indo from './lang/indo'
import vi from './lang/vi'
import tr from './lang/tr'
import it from './lang/it'

export const i18n = createI18n({
  locale: getPageLangCode(),
  fallbackLocale: 'en',
  messages: {
    zhCN,
    zhTW,
    en,
    ja,
    ar,
    ko,
    de,
    fr,
    ru,
    es,
    pt,
    th,
    indo,
    vi,
    tr,
    it,
  },
})

export const setupI18n = (app: App) => {
  app.use(i18n)
}
